<template>
  <div class="content-wrapper">    
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Offering Management
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Offerings</li>
        <li class="active">Offerings List</li>
      </ol>      
    </section>

    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default margin-bottom-0px">
            <div class="box-header with-border">
              <h3 class="box-title">Offerings List</h3>
              <div class="action-button pull-right">  
                <!-- <input type="button" :disabled="loading" class="btn btn-primary mrgn-right-20px" value="Add Keyword" v-on:click="showModal()" /> -->
                <router-link class="btn btn-primary" :to="`create`">Add Offering</router-link>
              </div>
            </div>

            <div class="box-footer no-border">
              <div class="row">
                <div class="col-md-12">
                  <vue-good-table
                    mode="remote"
                    styleClass="vgt-table good-table condensed striped"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :columns="columns"
                    :rows="offeringData"
                    :totalRows="offeringCount"
                     :pagination-options="{
                        enabled: true,
                        perPage: 20
                    }">
                    <div slot="emptystate"><nv-empty-state icon="fa-cubes" title="No offerings found" hint="Try changing the filters, or add a new offering." action-label="Add offering" action-to="/offering-manager/create" /></div>
                      <template slot="loadingContent">
                        <!-- Empty loading screen to disable default loading -->
                      </template>
                      <template slot="table-row" slot-scope="props">
                        <slot :props="props" />
                        <span v-if="props.column.field == 'createdAt'">
                          {{formatDate(props.formattedRow[props.column.field], 'd/M/Y hh:ss')}}
                        </span>
                        <span v-else-if="props.column.field == 'edit'">
                          <router-link :to="`update?offeringId=${props.row.id}`">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                          </router-link>
                        </span>
                        <span v-else>{{props.formattedRow[props.column.field]}}</span>
                        
                      </template>    
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>  
      </div>       
    </section>
    

    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>  
  
</template>
<script>
import api from '../../../utils/api'
import { formatDate, getSelectorValue } from '../../../utils/utilities'
import moment from 'moment'
import flatPickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'
export default {
  name: 'offeringList',
  components: {
    flatPickr
  },
  mounted () {
    flatPickr('input[placeholder="Select Date Range', {
      dateFormat: 'd-m-Y',
      mode: 'range',
      allowInput: true,
      onClose: function (selectedDates, dateStr, instance) {
        if (selectedDates.length === 1) {
          instance.setDate([selectedDates[0], selectedDates[0]], true)
        }
      }
    })
    this.getofferingList()
  },
  data () {
    return {
      formatDate: formatDate,
      loading: true,
      offeringData: [],
      offeringCount: 0,
      tableQueryParams: {
        columnFilters: {},
        sort: {
          createdAt: 'desc'
        },
        page: 1,
        perPage: 20
      },
      previousQueryParams: {},
      columns: [
        {
          label: 'Offering Name',
          field: 'legacy_name',
          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search Offering'
          }
        },
        {
          label: 'Created On',
          field: 'createdAt',
          sortable: true,
          filterable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Select Date Range'
          }
        },
        {
          label: 'Edit',
          field: 'edit',
          sortable: false
        }
      ]
    }
  },
  methods: {
    updateParams (newProps) {
      this.tableQueryParams = {...this.tableQueryParams, ...newProps}
    },
    onPageChange (params) {
      this.updateParams({page: params.currentPage})
      this.getofferingList()
    },
    onPerPageChange (params) {
      this.updateParams({perPage: params.currentPerPage})
      this.getofferingList()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          [this.columns[params.columnIndex].field]: params.sortType
        }
      })
      this.getofferingList()
    },
    onColumnFilter (params) {
      let appliedFilter = {}
      for (const key in params.columnFilters) {
        if (key === 'createdAt') {
          const filterDates = params.columnFilters[key].split(' to ')
          if (filterDates.length && filterDates[0]) {
            appliedFilter['fromDt'] = moment(filterDates[0], 'DD/MM/YYYY').startOf('day').utc(true)
            appliedFilter['toDt'] = moment(filterDates[1] || filterDates[0], 'DD/MM/YYYY').endOf('day').utc(true)
          }
        } else if (params.columnFilters[key]) {
          appliedFilter[key] = params.columnFilters[key]
        }
      }
      this.updateParams({columnFilters: appliedFilter})
      this.getofferingList()
    },
    /**
     * @function getofferingList
     * @description Get offerings from database
     */
    getofferingList () {
      this.loading = true

      let queryParams = {
        skip: this.tableQueryParams.perPage * (this.tableQueryParams.page - 1),
        limit: this.tableQueryParams.perPage,
        sort: this.tableQueryParams.sort,
        selector: getSelectorValue(this.tableQueryParams.columnFilters)
      }

      if (JSON.stringify(this.previousQueryParams) === JSON.stringify(queryParams)) {
        this.loading = false
        return
      } else if (JSON.stringify(this.previousQueryParams.selector) !== JSON.stringify(queryParams.selector) || JSON.stringify(this.previousQueryParams.sort) !== JSON.stringify(queryParams.sort)) {
        queryParams.skip = 0
        this.tableQueryParams.page = 1
      }
      api.buildRequest('getOfferingList', 'POST', queryParams)
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.previousQueryParams = queryParams
              this.offeringData = response.data.payload.offeringList
              this.offeringCount = response.data.payload.offeringCount
            } else {
              this.$swal({
                type: 'error',
                text: 'An error occurred'
              })
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    }
  }
}
</script>
<style>
.vgt-inner-wrap.is-loading {
  opacity: 1 !important;
  pointer-events: auto !important;
}
.mrgn-right-20px {
  margin-right: 20px;
}
.good-table td {
  white-space: normal;
}
.loader {
  z-index: 9999;
  position: fixed;
  transform: translate(-50%,-50%);
  top:50%;
  left:50%;
}
.noaction {
  cursor: pointer;
  pointer-events: none;
}
.pagination {
  display: inline-block;
  margin-top: 0;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}
.searchBox {
  width: 250px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
}
.margin-bottom-0px {
  margin-bottom: 0px; 
}
.vgt-left-align {
  padding-left: 16px !important;
}
</style>


// WEBPACK FOOTER //
// offeringList.vue?79533b14